import { DealAgentChat } from "src/types/dealAgent";

export const defaultDealAgentChat: DealAgentChat = {
  id: undefined,
  question: '',
  answer: "",
  sessionId: null,
  helpful: null,
  action: "",
  citations: null,
  showPlan: true,
  creating: true,
  events: [],
  thinking: null,
  error: {
    message: "",
    code: 0,
  },
};

export const responseEventTypes = ['answer', 'critique_answer', 'final_answer'];

/**
 * mergeStreamEventIntoChats a single SSE event into the chats list.
 *   - Every event is appended to chat.events[]
 *   - On "final_answer": answer, citations, session, id and loading flag are updated
 */
export const mergeStreamEventIntoChats = ( // merge the stream event into the chats list
  chats: DealAgentChat[],
  chatId: string,
  event: any
): DealAgentChat[] => {
  return chats.map((chat) => {
    if (chat.id !== chatId) return chat; // old chats

    // new chats are added to the events array
    const events = [...(chat.events ?? []), event];

    if (event.type === "final_answer") { // final answer
      return {
        ...chat,
        events,
        id: event.id ?? chat.id,
        sessionId: event.session ?? chat.sessionId,
        answer: event.payload ?? chat.answer,
        thinking: event.payload?.thinking ?? null,
        showPlan: event.payload?.showPlan ?? chat.showPlan,
        creating: false,
      };
    }

    return { ...chat, events }; // return the updated chat (current)
  });
}

export const globalAgentSuggestion = [
  {
      label: "What are the common pricing concerns?",
  },
  {
      label: "What are the reasons for timeline delays in deals across the pipeline?",
  },
  {
      label: "What are the deals that was created in last week? What stage are they in?",
  }
]